<template>
	<component :is="innerComponent" v-bind="innerComponentProps" />
</template>

<script>
const shallowEqualArrays = require('shallow-equal/arrays');

export default {
	name: 'CMSComponent',
	props: {
		content: {
			type: String,
			required: true,
		},
		props: {
			type: Object,
			required: true,
		},
		tag: {
			type: String,
			default: "div",
		},
	},
	data() {
		return {
			innerComponentProps: {},
			innerComponent: {
				name: "InnerCMSComponent",
				components: {},
				props: Object.keys(this.props),
				template: `<${this.tag}>${this.content}</${this.tag}>`,
			},
		};
	},
	methods: {
		updateInnerComponent(propKeys) {
			this.innerComponent = {
				name: "InnerCMSComponent",
				components: { },
				props: propKeys,
				template: `<${this.tag}>${this.content}</${this.tag}>`,
			};
		},
		updateInnerComponentProps(props) {
			this.innerComponentProps = props;
		},
	},
	watch: {
		content(content, oldContent) {
			if (content !== oldContent) {
				this.updateInnerComponent(Object.keys(this.props));
			}
		},
		tag(tag, oldTag) {
			if (tag !== oldTag) {
				this.updateInnerComponent(Object.keys(this.props));
			}
		},
		props(props, oldProps) {
			if (!shallowEqualArrays(Object.keys(props), Object.keys(oldProps))) {
				this.updateInnerComponent(Object.keys(props));
			} else {
				this.updateInnerComponentProps(props);
			}
		},
		innerComponent(newComponent, oldComponent) {
			if (!shallowEqualArrays(newComponent.props, oldComponent.props)) {
				this.updateInnerComponentProps(this.props);
			}
		},
	},
	mounted() {
		this.updateInnerComponentProps(this.props);
	},
};
</script>



// WEBPACK FOOTER //
// src/components/base/CMSComponent.vue